<script lang="ts" setup>
const props = defineProps({
  hint: {
    type: String,
    required: false,
  },
  showAsAlert: {
    type: Boolean,
    default: false,
  },
  maxWidth: {
    type: String,
    default: "400px",
  },
});

const tooltip = computed(() => {
  return props.showAsAlert == true ? undefined : props.hint;
});

const controller = useNewDialogController();

const onClick = () => {
  if (props.showAsAlert != true) {
    controller.value.open();
    return;
  }

  useBaseAlert("", props.hint);
};
</script>

<template>
  <span class="hint-container inline-flex align-middle">
    <BasePopover :controller="controller">
      <BaseIconCircleHelp
        @click.stop.prevent="onClick"
        class="text-primary-default cursor-help"
        size="18"
      />
      <template #content>
        <div
          class="p-2 rounded bg-dark border-dark text-primary-on"
          :style="{
            'max-width': maxWidth,
          }"
        >
          <slot>
            {{ hint }}
          </slot>
        </div>
      </template>
    </BasePopover>
  </span>
</template>

<style>
.hint-popper {
  .v-popper__arrow-inner {
    @apply border-dark;
  }
}
</style>
